import { View, Pressable } from 'react-native';
import styled from 'styled-components/native';
import webStyled from 'styled-components';

import { Text } from 'app/src/styles';
import colors from 'app/src/styles/colors';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCaretLeft } from '@fortawesome/free-solid-svg-icons';

export const Container = styled(View)`
  flex-direction: column;
  height: 80vh;
`;

export const ContainerWithFlash = styled(View)`
`;

export const ColumnContainer = styled(View)`
  width: 100%;
`;

export const Column = styled(View)`
  flex: 1;
`;

export const BorderedContainer = styled(View)`
  padding: 5px;
  border-color: black;
  border-width: 3px;
  border-style: solid;
`;

export const LeftContainer = styled(View)`
  width: 50%;
`;

export const RightContainer = styled(View)`
  width: 50%;
`;

export const Title = styled(Text)`
  font-size: 20px;
  font-weight: 600;
`;

export const Subtitle = styled(Text)`
  font-size: 16px;
  align-self: center;
`;

export const NoticesContainer = styled(View)`
  padding: 10px;
`;

export const NoticeContainer = webStyled.div`
  display: flex;
  background-color: ${colors.elRed};
  min-height: 40px;
  border-radius: 4px;
  margin-top: 4px;
  margin-bottom: 4px;
  align-items: center;
  justify-content: space-around;

  ${props => props.notice ? `
    @keyframes blink-then-fade {
      0% { opacity: 0; }
      8% { opacity: 1; }
      16% { opacity: 0; }
      24% { opacity: 1; }
    }

    animation-duration: 6s;
    animation-name: blink-then-fade;
  ` : ''};

  opacity: 1;
`;

export const NoticeText = styled(Title)`
  color: white;
`;

export const NoticesSelectContainer = styled(View)`
  flex-direction: row;
  gap: 20px;
`;

export const SuggestionsContainer = styled(View)`
  flex-direction: row;
  justify-content: stretch;
  margin-bottom: 10px;
  gap: 10px;
`;

export const Split = styled(View)`
  margin-top: 10px;
  margin-bottom: 10px;
  border-bottom-color: black;
  border-bottom-width: 3px;
  border-bottom-style: solid;
`;

export const SaleAssetContainer = styled(View)`
  min-height: 100px;
  flex-direction: row;
  background-color: ${props => props.active ? 'yellow' : 'none'};
  padding-bottom: 10px;
  border-width: 2px;
  border-style: solid;
  border-color: ${props => props.groupPosition ? 'blue' : 'white'};
  ${props => 'first' === props.groupPosition && (
    'border-bottom-color: white;'
  )}
  ${props => 'last' === props.groupPosition && (
    'border-top-color: white; padding-bottom: 0px; margin-bottom: 10px;'
  )}
  ${props => 'middle' === props.groupPosition && (
    'border-top-color: white; border-bottom-color: white;'
  )}
`;

export const StyledTextInput = webStyled.input`
  flex: 1;
`;

export const Field = styled(View)`
  flex-direction: row;
`;

export const Label = styled(Text)`
  margin-right: 10px;
  align-self: center;
`;

export const Value = styled(Text)`
  font-weight: 600;
`;

export const Going = styled(View)`
  background-color: orange;
  padding: 10px;
`;

export const GoingText = styled(Subtitle)`
  font-weight: 900;
  color: white;
`;

export const GOING_BUTTONS = [
  { status: 'Going Once', color: colors.biddingOrange },
  { status: 'Going Twice', color: colors.biddingPurple },
];

export const goingColor = saleAsset => (
  GOING_BUTTONS.find(({ status }) => status === saleAsset.biddingStatus)?.color
);

export const ButtonContainer = styled(Pressable)`
  background-color: ${colors.elGreen}
  flex: 1;
  padding: 10px;
  align-items: center;
  justify-content: space-around;
`;

const ButtonLabel = styled(Text)`
  color: white;
  font-weight: 700;
`;

export const Button = props => {
  const { title, style, labelStyle, disabled } = props;
  let { color, onPress } = props;

  if (disabled) {
    onPress = () => {};
    color = colors.elGray;
  }

  return (
    <ButtonContainer
      onPress={onPress}
      style={{
        ...style,
        backgroundColor: (color || colors.elGreen),
        borderRadius: '10px'
      }}
    >
      <ButtonLabel style={labelStyle}>{title}</ButtonLabel>
    </ButtonContainer>
  );
};

//Bidding Header

export const HeaderBackButton = props => {
  const { title, style, labelStyle, disabled } = props;
  let { color, onPress } = props;

  if (disabled) {
    onPress = () => {};
    color = colors.elGray;
  }

  return (
    <ButtonContainer
      onPress={onPress}
      style={{
        ...style,
        backgroundColor: (color || colors.elGreen),
        display: 'flex',
        flexDirection: 'row',
        maxWidth: 'fit-content',
        gap: '5px',
        borderRadius: '25px',
        paddingTop: '2px',
        paddingBottom: '5px',
      }}
    >
      <FontAwesomeIcon
        icon={faCaretLeft}
        title="Return to Auction App"
        color="white"
        size='xl'
      />
      <ButtonLabel style={labelStyle}>{title}</ButtonLabel>
    </ButtonContainer>
  );
};

export const HeaderContainer = styled(View)`
  display: flex;
  flex: 1;
  height: 50px;
  max-height: 50px;
  flex-direction: row;
  justify-content: space-between;
  background-color: ${colors.elGray};
`;

export const HeaderLeft = styled(View)`
  display: flex;
  flex-direction: column;
  flex: 0.8;
  padding: 0px 0px 5px 20px;
`;

export const HeaderTitle = styled(Text)`
  font-size: 24px;
  font-weight: 600;
`;

export const HeaderRight = styled(View)`
  display: flex;
  flex-direction: row;
  flex: 0.2;
  justify-content: center;
`;

export const HeaderButtons = styled(View)`
  display: flex;
  flex-direction: row;
  gap: 30px;
  max-height: 20px;
`;

export const SwitchText = styled(Text)`
  display: flex;
  flex-direction: row;
  align-self: center;
  margin-left: 20px;
  margin-right: -10px;
`;

export const PreBidAlert = styled(Text)`
  padding: 10px;
  background-color: ${colors.elRed}
  color: #fff;
  align-self: center;
  font-size: 16px;
`;

//Bidding Header

//Bids

export const PaddleStepsContainer = styled(View)`
  width: 100%;
`;

export const PaddleServiceLabel = styled(Text)`
  margin-top: 10px;
`;

export const PaddleStepsRow = styled(View)`
  display: flex;
  flex-direction: row;
  gap: 5px;
  margin-bottom: 5px;
`;

export const CurrentBidDetailsContainer = styled(View)`
  color: #fff;
  text-align: center;
  line-height: 25;
  font-size: 16px;
`;

export const CurrentBidValue = styled(Text)`
  font-size: ${props => props.fontSize};
  font-weight: 900;
  color: ${props => props.color};
  align-self: center;
  padding-top: 0px;
`;

export const CustomBidButton = props => {
  const { title, style, labelStyle, disabled } = props;
  let { color, onPress } = props;

  // if (disabled) {
  //   onPress = () => {};
  //   color = colors.elGray;
  // }

  return (
    <ButtonContainer
      onPress={onPress}
      style={{
        ...style,
        width: '100px',
        backgroundColor: color,
        borderRadius: '10px'
      }}
    >
      <ButtonLabel style={labelStyle}>{title}</ButtonLabel>
    </ButtonContainer>
  );
};

//Bids

//BidHistory

export const BidListDetail = styled(View)`
  margin-left: 10px;
  margin-right: 10px
`;

export const BidListText = styled(Text)`
  color: ${props => props.reversed ?
    colors.biddingBrightRed :
    props.color || '#000'
  }
`;

//BidHistory


//Hud

export const LotDetails = styled(Text)`
  font-size: 32px;
  alignSelf: center;
`;

export const HudPrice = styled(Text)`
  font-size: 128px;
  font-weight: 900;
  align-self: center;
  padding-top: 40px;
  color: ${props => props.color}
`;

export const HudBidderDetailsContainer = styled(View)`
  display: flex;
  flex-direction: row;
  justify-content: space-around;
  margin-bottom: 60px;
`;

export const HudBidderDetails = styled(Text)`
  font-size: 32px;
  font-weight: 900;
  align-self: center;
  padding-top: 10px;
  color: ${props => props.color}
`;

export const HudAssetDetailsContainer = styled(View)`

`;

export const HudAssetDetails = styled(Text)`
  font-size: 32px;
  font-weight: bold;
  color: ${props => props.color}
`;

export const HudChoiceContainer = styled(View)`
  marginTop: 10px;
  borderColor: blue;
  borderWidth: 6px;
  padding: 5px;
`;

export const HudChoiceDetails = styled(Text)`

`;

//Hud
